import React, {PureComponent} from "react"

import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import RewardWalletBalanceQuery, {RewardWalletBalanceQueryResult} from "@irati/wallet/apollo/query/RewardWallet"
import getId from "@irati/utils/id"

import {StyledHeaderCard, InnerWrapper, ColumnWrapper, StyledCaption, AvailableBalance} from "../styled/HeaderBalance"
import HeaderBalanceButtons from "./HeaderBalanceButtons"

interface Props {
  id: string
}

class RewardWalletHeaderBalance extends PureComponent<Props> {
  render() {
    const {id} = this.props
    return (
      <StyledHeaderCard>
        <RewardWalletBalanceQuery>
          {({data}: RewardWalletBalanceQueryResult) => {
            const {availableBalance, currency} = data.rewardWallet
            const fractionDigits = availableBalance.toString().length > 8 ? 0 : 2
            return (
              <InnerWrapper>
                <ColumnWrapper>
                  <StyledCaption flush>
                    <FormattedMessage id="wallet.reward.intro.available" />
                  </StyledCaption>
                  <AvailableBalance id={getId("rewardWalletBalance", id)}>
                    <FormattedCurrency
                      isCents={false}
                      currency={currency}
                      value={availableBalance}
                      minimumFractionDigits={fractionDigits}
                      maximumFractionDigits={fractionDigits}
                    />
                  </AvailableBalance>
                </ColumnWrapper>
                <ColumnWrapper>
                  <HeaderBalanceButtons availableBalance={availableBalance} />
                </ColumnWrapper>
              </InnerWrapper>
            )
          }}
        </RewardWalletBalanceQuery>
      </StyledHeaderCard>
    )
  }
}

export default RewardWalletHeaderBalance
